import { Injectable } from '@angular/core';
import { mockLoanDetailDtos as originalMockLoanDetails } from '../loans/loan.dto.mock';
import { deepClone } from '../../utils/deep-clone';
import { LoanDetailDto } from '../../../models/dtos/loan-detail.dto';
import { RecurringPaymentForm } from '../../../models/payment.model';
import { RecurringPaymentDetailsMapper } from '../../../mappers/recurring-payment-details.mapper';
import { RecurringPaymentDetailsDto } from '../../../models/dtos/recurring-payment-details.dto';

@Injectable({
  providedIn: 'root'
})
export class MockDataStore {
  loanDetails: Record<string, LoanDetailDto> = deepClone(originalMockLoanDetails);

  reset(): void {
    this.loanDetails = deepClone(originalMockLoanDetails);
  }

  getLoanDetail(loanId: string): LoanDetailDto | undefined {
    if (!loanId) {
      throw new Error('Invalid loan ID provided');
    }
    return this.loanDetails[loanId];
  }

  getRecurringPayment(recurringPaymentId: string): RecurringPaymentDetailsDto | undefined {
    for (const loan of Object.values(this.loanDetails)) {
      if (loan.recurringPayment && loan.recurringPayment.row_id === recurringPaymentId) {
        return loan.recurringPayment;
      }
    }
    return undefined;
  }

  updateRecurringPayment(recurringPaymentId: string, data: RecurringPaymentForm): boolean {
    for (const loanId in this.loanDetails) {
      const loan = this.loanDetails[loanId];
      if (loan.recurringPayment && loan.recurringPayment.row_id === recurringPaymentId) {
        this.loanDetails[loanId] = {
          ...loan,
          recurringPayment: {
            row_id: recurringPaymentId,
            ...RecurringPaymentDetailsMapper.toDto(data),
          },
          paymentSettings: {
            ...loan.paymentSettings,
            recurringPaymentExists: true,
          }
        };
        return true;
      }
    }
    return false;
  }

  deleteRecurringPayment(recurringPaymentId: string): boolean {
    for (const loanId in this.loanDetails) {
      const loan = this.loanDetails[loanId];
      if (loan.recurringPayment && loan.recurringPayment.row_id === recurringPaymentId) {
        this.loanDetails[loanId] = {
          ...loan,
          recurringPayment: null,
          paymentSettings: {
            ...loan.paymentSettings,
            recurringPaymentExists: false,
          }
        };
        return true;
      }
    }
    return false;
  }
}
